import { render, staticRenderFns } from "./Pasta.vue?vue&type=template&id=25b740b0&scoped=true"
import script from "./Pasta.vue?vue&type=script&lang=ts"
export * from "./Pasta.vue?vue&type=script&lang=ts"
import style0 from "./Pasta.vue?vue&type=style&index=0&id=25b740b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b740b0",
  null
  
)

export default component.exports